package com.pincer.app.viewmodel

import com.pincer.app.ApplicationState
import com.pincer.app.I18n
import com.pincer.core.model.tree.Answer
import com.pincer.core.model.tree.Participant
import com.pincer.core.model.tree.QuestionFormat
import com.pincer.core.model.tree.CHATS_SCOPE
import com.pincer.core.model.tree.PERMISSIONS_SCOPE
import com.pincer.core.model.tree.QUESTIONS_SCOPE
import com.pincer.core.model.tree.CANDIDATES_SCOPE
import com.pincer.core.model.tree.NAME_SCOPE
import com.pincer.core.model.tree.DESCRIPTION_SCOPE
import com.pincer.core.model.tree.RULES_SCOPE
import com.pincer.core.model.tree.PARTICIPANTS_SCOPE
import com.pincer.core.model.tree.PARTICIPANTS_ANSWERS_SCOPE
import com.pincer.core.model.tree.PARTICIPANTS_RULES_SCOPE
import com.pincer.core.model.tree.PARTICIPANTS_ROLES_SCOPE
import com.pincer.core.model.drafts.QuestionDraft
import com.pincer.core.model.drafts.AnswerDraft
import com.pincer.core.functions.termsNeeded
import com.pincer.core.functions.getAnswer
import com.pincer.core.functions.readable
import com.pincer.core.functions.readablePid
import com.pincer.core.functions.getRolesForParticipant
import com.pincer.core.functions.validateText
import com.pincer.core.functions.validateEmail
import com.pincer.core.functions.validateCode
import com.pincer.core.functions.validateQuestionCode
import com.pincer.core.functions.validateRegex
import com.pincer.core.functions.validateRoles
import com.pincer.core.functions.validateRole
import com.pincer.core.functions.validateOptions
import com.pincer.core.functions.validateAnswer
import com.pincer.core.functions.validateRules

fun pincerQuestions(state: ApplicationState, context: Node) {
    val pincer = state.pincer()!!
    if (pincer.questions.size > 0 && state.pincerSelf() != null && state.checkRead(QUESTIONS_SCOPE)) {
        context.node("questions") {
            for (questionId in pincer.questions.keys) {
                val question = pincer.questions[questionId]!!
                val answer: Answer? = state.pincerSelf()!!.answers[questionId]
                val uiAnswer: AnswerDraft = state.pincerUiSelf()!!.getOrAddAnswer(questionId)
                // Typed answers are fields (the answer, and a way to change it); a select or checkbox shows its own value
                if (question.formatLikeSimple() || question.format == QuestionFormat.MULTILINE.toString()) {
                    val textInBox = uiAnswer.wording ?: answer?.wording
                    val problem = validateAnswer(question, textInBox)
                    field(state = state, key = questionId, wording = question.wording, value = answer?.wording, problem = problem) {
                        if (question.format == QuestionFormat.MULTILINE.toString()) {
                            multiline(key = "setAnswer", action = Action.SetAnswer(questionId), wording = textInBox ?: "", problem = problem)
                            possibleProblem(problem)
                        }
                        else {
                            val picker = when (question.format) {
                                QuestionFormat.DATE.toString()     -> Rich.DateTimePicker(PickerFormat.DATE)
                                QuestionFormat.TIME.toString()     -> Rich.DateTimePicker(PickerFormat.TIME)
                                QuestionFormat.DATETIME.toString() -> Rich.DateTimePicker(PickerFormat.DATETIME)
                                else                               -> null
                            }
                            input(key = "setAnswer", action = Action.SetAnswer(questionId), wording = textInBox ?: "", problem = problem, rich = picker)
                            possibleProblem(problem)
                            // The plain version of a picker: say what to type
                            if (picker != null && !question.hasHelpText()) helpText("answer-format-${picker.format}")
                        }
                        if (question.hasHelpText()) helpText(question.helpText!!)
                    }
                    continue
                }
                node(key = questionId, wording = question.wording) {
                    if (question.format == QuestionFormat.SELECT.toString()) {
                        // The answer is the option's wording, so each choice is its own key
                        val controlChoices = mutableMapOf<String, String>()
                        if (question.options != null) {
                            for (line in question.options!!.split("\n")) {
                                controlChoices.put(line, line)
                            }
                        }
                        select(key = "setAnswer", action = Action.SetAnswer(questionId), wording = answer?.wording ?: "", controlChoices = controlChoices)
                    }
                    else if (question.format == QuestionFormat.CHECKBOX.toString()) {
                        val trueOrFalse = if (answer != null && answer.wording == "true") "true" else "false"
                        checkbox(key = "setAnswer", action = Action.SetAnswer(questionId), wording = trueOrFalse)
                    }
                    if (question.hasHelpText()) {
                        helpText(question.helpText!!)
                    }
                }
            }
        }
    }
}